import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'environments/environment';


@Injectable({providedIn: 'root'})
export class IconsService
{
    /**
     * Constructor
     */
    constructor()
    {
        const domSanitizer = inject(DomSanitizer);
        const matIconRegistry = inject(MatIconRegistry);

        // Register icon 

        const basePath = `${environment.assetsBaseUrl}/icons/`;
        const iconSets = [
            { ns: null, file: 'material-twotone.svg' },
            { ns: 'mat_outline', file: 'material-outline.svg' },
            { ns: 'mat_solid', file: 'material-solid.svg' },
            { ns: 'feather', file: 'feather.svg' },
            { ns: 'heroicons_outline', file: 'heroicons-outline.svg' },
            { ns: 'heroicons_solid', file: 'heroicons-solid.svg' },
            { ns: 'heroicons_mini', file: 'heroicons-mini.svg' },
            { ns: 'dms-custom', file: 'dms-custom.svg' }
        ];

        iconSets.forEach(icon => {
            const url = domSanitizer.bypassSecurityTrustResourceUrl(basePath + icon.file);

            if (icon.ns) {
                matIconRegistry.addSvgIconSetInNamespace(icon.ns, url);
            } else {
                matIconRegistry.addSvgIconSet(url);
            }
        });
        // TODO - register custom icons for file types
    }
}
